import { createApi } from '@reduxjs/toolkit/query/react';
import { getBaseQuery } from '@edikk-edikk/redux';
import { Container } from 'inversify';
import { LoadResponseType } from '#reviewList/api/types/LoadResponseType';
import { API_REVIEW_LIST_NAME, LOAD_URL } from '#reviewList/constants';
import { LoadPayloadType } from '#reviewList/api/types/LoadPayloadType';
import { LoadMorePayloadType } from '#reviewList/api/types/LoadMorePayloadType';

const getApiReviewList = (diContainer: Container) => {
  const apiReviewList = createApi({
    reducerPath: API_REVIEW_LIST_NAME,
    baseQuery: getBaseQuery(diContainer),
    endpoints: (builder) => ({
      init: builder.query<LoadResponseType, number>({
        query: (cityId) => ({
          url: LOAD_URL,
          params: {
            cityId,
          },
        }),
      }),
      filter: builder.query<LoadResponseType, LoadPayloadType>({
        query: (payload) => ({
          url: LOAD_URL,
          params: {
            ...payload,
          },
        }),
        async onQueryStarted({ cityId }, { dispatch, queryFulfilled }) {
          const { data } = await queryFulfilled;
          dispatch(
            apiReviewList.util.updateQueryData('init', cityId, (draft) => {
              draft.reviews = data.reviews;
            }),
          );
        },
      }),
      loadMore: builder.query<LoadResponseType, LoadMorePayloadType>({
        query: (payload) => ({
          url: LOAD_URL,
          params: {
            ...payload,
          },
        }),
        async onQueryStarted({ cityId }, { dispatch, queryFulfilled }) {
          const { data } = await queryFulfilled;
          dispatch(
            apiReviewList.util.updateQueryData('init', cityId, (draft) => {
              draft.reviews.pagination = data.reviews.pagination;
              draft.reviews.items.push(...data.reviews.items);
            }),
          );
        },
      }),
    }),
  });

  return apiReviewList;
};

export { getApiReviewList };
